import EventEmitter from './EventEmitter.js'
import Experience from '../Experience.js'

/**
 * Mouse
 * Tracks normalized mouse position (0..1) with lerp smoothing (factor 0.04).
 * .current follows .target with inertia; Y is flipped to match WebGL UV convention.
 */
export default class Mouse extends EventEmitter {
    constructor() {
        super()
        this.experience = new Experience()
        this.sizes      = this.experience.sizes
        this.time       = this.experience.time

        this.target  = { x: 0.5, y: 0.5 }
        this.current = { x: 0.5, y: 0.5 }

        this.setListeners()
    }

    setListeners() {
        window.addEventListener('mousemove', (e) => {
            this.target.x = e.clientX / this.sizes.width
            this.target.y = 1 - e.clientY / this.sizes.height
        })

        this.time.on('tick', () => {
            this.current.x += (this.target.x - this.current.x) * 0.04
            this.current.y += (this.target.y - this.current.y) * 0.04
        })
    }
}
